import React, { useState } from 'react';
import { api } from '../api/client';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await api.login(email, password);
      login(res);
      navigate('/account');
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Login failed';
      alert(msg);
    }
  };

  return <form onSubmit={submit}>
    <h2>Login</h2>
    <input placeholder='Email' value={email} onChange={e => setEmail(e.target.value)} />
    <input placeholder='Password' type='password' value={password} onChange={e => setPassword(e.target.value)} />
    <button type='submit'>Login</button>
  </form>;
};
export default Login;
